export const PENDING = 'pending';
export const APPROVED = 'approved';
export const DECLINED = 'declined';
export const EDIT_LISTING_PAGE = 'EditListingPage';
export const MANAGE_SHIPPING_THROUGH_PLATFORM = 'platform';
export const MANAGE_OWN_SHIPPING = 'own';
export const VIDEO = 'video';
export const IMAGE = 'image';
export const UNKNOWN = 'unknown';
export const YES = 'yes';
export const NO = 'yo';
export const CREATED_AT = 'createdAt';
export const RELEVANCE = 'relevance';
export const KEYWORDS = 'keywords';

export const topbarListingCategories = [
  { id: 'TopbarDesktop.music', category: 'cat_music' },
  { id: 'TopbarDesktop.entertainment', category: 'cat_entertainment' },
  { id: 'TopbarDesktop.sports', category: 'cat_sports' },
  { id: 'TopbarDesktop.history', category: 'cat_history' },
  { id: 'TopbarDesktop.other', category: 'cat_other' },
  { id: 'TopbarDesktop.all', category: '' },
];

export const exploreCategories = [
  { id: 'TopbarDesktop.fans', page: 'LandingPage' },
  { id: 'TopbarDesktop.talent', page: 'LandingPage' },
  { id: 'TopbarDesktop.brands', page: 'LandingPage' },
  { id: 'TopbarDesktop.schools', page: 'LandingPage' },
  { id: 'TopbarDesktop.agencies', page: 'LandingPage' },
];

export const AdditionalFilters = [
  { key: 'buying_format', schemaType: 'buying_format' },
  { key: 'authenticationType', schemaType: 'authenticationType' },
  { key: 'show_only', schemaType: 'show_only' },
];
export const showOnlyOptions = [
  { key: 'active_items', label: 'Active Items' },
  { key: 'sold_items', label: 'Sold Items' },
];

export const LOCAL_FAVORITES_KEY = 'localFavorites';
export const VIEW_ALL = 'all';
export const USD = 'USD';

export const EDIT = 'edit';
export const BOOKING = 'booking';
export const CUSTOM = 'Custom';
export const JOB_POST = 'jobPost';
export const SINGLE_JOB_POST = 'SinglejobPost';
export const BULK_JOB_POST = 'BulkJobPost';
export const NEW = 'new';
export const QUOTE = 'quote';
export const PERKS = 'Perks';
export const CAMPAIGN = 'Campaign';
export const REWARD = 'Reward';
export const PHONE = 'phone';
export const UNLOCKABLE_CONTENT = 'Unlockable Content';
export const DIRECT_MESSAGE = 'Direct Message';
export const JOBS = 'jobs';
/**
 * Constants for image variant prefixes and sizes
 */
export const IMAGE_VARIANTS = {
  PREFIX: 'listing-card',
  SIZES: {
    BASE: 400,
    DOUBLE: 800,
    QUAD: 1600,
    SEXTUPLE: 2400,
  },
};

export const IMAGE_FIELDS = [
  'variants.default', // Original
  'variants.scaled-small', // Scaled variants
  'variants.scaled-medium',
  'variants.scaled-large',
  'variants.scaled-xlarge',
  'variants.facebook', // Social media
  'variants.twitter',
  'variants.square-small', // Avatars
  'variants.square-small2x',
];

// Define filter options for the pills
export const talentOfferingFilterOptions = [
  {
    id: 'pub_isSignatureServices',
    labelId: 'TalentOfferingPage.signatureServices',
    defaultMessage: 'Signature Services',
  },
  {
    id: 'pub_isEnhancedServices',
    labelId: 'TalentOfferingPage.enhancedServices',
    defaultMessage: 'Enhanced Services',
  },
  {
    id: 'pub_isTalentPlusServices',
    labelId: 'TalentOfferingPage.talentPlus',
    defaultMessage: 'Talent Plus',
  },
  { id: 'pub_auctions', labelId: 'TalentOfferingPage.auctions', defaultMessage: 'Auctions' },
];

export const SECTION = 'section';
export const PLUS = 'plus';
export const PREMIER = 'premier';
export const ENTER = 'Enter';
export const CERTAIN = 'certain';
export const ALL = 'all';
export const OPPORTUNITIES = 'opportunities';
export const SERVICE = 'service';
export const SCHOOL = 'school';
export const BRAND = 'brand';
export const AGENCY = 'agency';
export const TALENT = 'talent';

export const ENDORSEMENT_OPTIONS = [
  'Facebook',
  'Instagram',
  'LinkedIn',
  'Meta',
  'Pinterest',
  'Snapchat',
  'TikTok',
  'Twitter',
  'YouTube',
];

export const CREATIVE_MEDIA_OPTIONS = [
  'Audio Creation',
  'Behind-the-Scenes Video',
  'Custom Articles',
  'Fitness Demonstration Video',
  'How-To Video',
  'Photo Creation',
  'Podcast Clip',
  'Product Testing',
  'Unboxing Video',
  'Video Creation with Audio',
  'Voiceover Recording',
];

export const APPEARANCE_OPTIONS = [
  'Autograph Session',
  'Camp Participation',
  'Digital Interview',
  'Esports Event Appearance',
  'Fundraising Event Appearance',
  'Game Appearance',
  'Golf Outing',
  'Halftime Appearance',
  'In-person Interview',
  'Media Day Appearance',
  'Meet and Greet',
  'Podcast',
  'Practice Appearance',
  'Production Shoot',
  'Skill Demonstration',
  'Speech',
  'Virtual Classroom Visit',
  'Watch Party',
];

export const SHOUTOUT_OPTIONS = [
  'Anniversary Shoutout',
  'Appreciation Shoutout',
  'Birthday Shoutout',
  'Congratulatory Message',
  'Custom',
  'Engagement Announcement',
  'Good Luck Message',
  'Holiday Shoutout',
  'Motivational Message',
  'Retirement Congratulations',
  'Wedding Shoutout',
];

export const AUTOGRAPH_OPTIONS = [
  'Custom Talent Provided',
  'Photo',
  'Poster',
  'Fan or Brand Provided Item',
  'Trading Card',
];

export const EXCLUSIVE_TRAINING_OPTIONS = [
  '1-on-1 Coaching',
  'Film Breakdown Session',
  'Group Training',
  'Virtual Training Camp',
];

export const MENTORSHIP_OPTIONS = [
  'Athlete Branding Consultation',
  'Career Development Mentorship',
  'Mentorship Discussion',
  'Mental Toughness Coaching',
  'Skill Development',
  'Sponsorship Consultation',
];

export const BUSINESS_DEVELOPMENT_OPTIONS = [
  'Corporate Event',
  'Networking Sessions',
  'Panel Discussion Participation',
];

export const UNLOCKABLE_CONTENT_OPTIONS = ['Direct Message', 'Photos', 'Posts', 'Videos'];

export const STRING = 'string';
export const NUMBER = 'number';
export const BOOLEAN = 'boolean';

export const PHOTO = 'Photo';
